import CommonService from "@/services/commons/CommonService";


const fecha_actual = (context, params) => {
  return CommonService.fecha_actual().then((res) => {
    context.commit('FECHA_ACTUAL', res.data.fecha_actual);
  });
};


export default {
  fecha_actual,
};